import { Injectable } from '@angular/core';
import { OverlayEventDetail } from '@ionic/core';

import { DesktopTPPRightColumnComponent } from './desktop-tpp-right-column.component';

/**
 * Helper class that mimics the interface of Ionic modals
 * A pseudo-modal is displayed in the right column of the task process page
 * (we call it pseudo as there is no overlay that prevents interacting with the rest of the app)
 */
export class PseudoModalInstance {
  private didDismissPromise: Promise<OverlayEventDetail>;
  private didDismissPromiseResolverFn: (OverlayEventDetail) => void;

  constructor() {
    this.didDismissPromise = new Promise(resolve => {
      this.didDismissPromiseResolverFn = resolve;
    });
  }

  onDidDismiss(): Promise<OverlayEventDetail> {
    return this.didDismissPromise;
  }

  dismiss(data?: any) {
    this.didDismissPromiseResolverFn({ data });
  }
}

@Injectable({
  providedIn: 'root',
})
export class DesktopTPPRightColumnService {
  private currentModal: PseudoModalInstance;
  private rightColumnComponent: DesktopTPPRightColumnComponent;

  private pendingComponent: any;
  private pendingComponentInputs: any;

  setRightColumnComponent(component: DesktopTPPRightColumnComponent) {
    this.rightColumnComponent = component;
    if (this.pendingComponent) {
      this.displayPseudoModal(this.pendingComponent, this.pendingComponentInputs);
      this.pendingComponent = null;
      this.pendingComponentInputs = null;
    }
  }

  displayPseudoModal(component, componentInputs): Promise<PseudoModalInstance> {
    if (this.currentModal) {
      this.dismissCurrentPseudoModal();
    }
    if (this.rightColumnComponent) {
      this.currentModal = new PseudoModalInstance();
      this.rightColumnComponent.displayPseudoModal(component, componentInputs);
    } else {
      // the public context pseudo modal is opened right away; the right column is not be ready yet
      this.pendingComponent = component;
      this.pendingComponentInputs = componentInputs;
    }

    // Return a promise, to follow Ionic's async modalController.create()
    return Promise.resolve(this.currentModal);
  }

  /**
   * Dismisses the currently displayed pseudo-modal
   */
  dismissCurrentPseudoModal(data?) {
    if (this.currentModal) {
      if (this.rightColumnComponent) {
        this.rightColumnComponent.clearPseudoModal();
      }
      this.currentModal.dismiss(data);
      this.currentModal = null;
    }
  }
}
